export default __webpack_public_path__ + "static/media/v.eee3fff0.mp4";